const api = '/api';
const data = '/data';
const quickTag = '/quickTag';
const conversational = '/conversational';

const baseURI = process.env.INCA_SERVER_URL;

console.log('baseURI:', baseURI);

export default {
    baseURI: baseURI,
    app: {
        baseHref: '/',
        title: 'inca portal'
    },
    api: {
        endpoints: {
            // AUTH
            auth: api + '/auth',
            invitation: api + '/invitation',

            users: api + '/users',
            tenants: api + '/tenants',

            client: api + '/clients',

            project: api + '/projects',

            payment: api + '/payment',
            dynata: api + `/panel/dynata`,
            news: api + '/news',

            feedback: api + '/feedback',
            upload: baseURI + data + '/file/upload',
            downloadPreviewData: baseURI + data + '/p/',
            uploadQuickTagFile: baseURI + data + '/file/uploadQuickTagFile',
            createQuickTagInstanceFromFile:
                baseURI + quickTag + '/instance/createFromFile',
            listQuickTagInstances: baseURI + quickTag + '/instance/list/',
            listQuickTagCredits: baseURI + quickTag + '/instance/credits/',
            listQuickTagCodeFrames: baseURI + quickTag + '/codeFrame/list/',
            createQuickTagCodeFrameFromFile:
                baseURI + quickTag + '/codeFrame/createFromFile',
            getTrainedModelSummaries:
                api + conversational + '/trainedModel/summaries'
        }
    },
    host: {
        domain: process.env.DOMAIN_NAME,
        bot: process.env.BOT_URL,
        dashboard: process.env.DASHBOARD,
        data: process.env.INCA_SERVER_URL + data,
        quickTag: process.env.QUICKTAG_URL
    }
};
